import request from '@/utils/request'
import { GetOrderOperationHistoriesReq, OrderOperationHistoriesItem } from '@/services/outbound/outboundUnallocated/types'
import { OperatorReplanBulkResult, OperatorReplanReq, OPERATOR_REPLAN_URL } from '@/services/outbound/outboundUnallocated/replan'

/** 운영자 미할당 재주입 — 202 응답에 동기 판정 결과가 실리고, 접수된 주문의 후속 처리 결과는 목록에서 확인한다. */
export const requestOperatorReplan = (params: OperatorReplanReq) =>
  request.post<ApiResponseV2<OperatorReplanBulkResult>, OperatorReplanReq>(OPERATOR_REPLAN_URL, params)

export const getOrderOperationHistories = (params: ApiPaginationReq<GetOrderOperationHistoriesReq>) =>
  request.post<ApiResponseV2<ApiPageResponse<OrderOperationHistoriesItem>>, ApiPaginationReq<GetOrderOperationHistoriesReq>>(
    `/api/v1/get-order-operation-histories`,
    params,
  )
